import FakeLink from "@/components/FakeLink/FakeLink";
import ProxyIcon from "@/components/icons/ProxyIcon";
import ManageProxyAction from "@/pages/products/actions/ManageProxyAction/ManageProxyAction";
import { productLabel } from "@/utilities/products";
import { EditOutlined } from "@ant-design/icons";
import styles from "./ProxyTag.module.scss";

export default function ProxyTag({
  proxy,
}: {
  proxy?: {
    productId: number;
    source: {
      id: number;
      weight: number;
      externalId: string;
      name: string;
    };
  };
}) {
  return (
    <span className={[styles.ProxyTag].join(" ")}>
      <ProxyIcon />
      {proxy ? (
        <ManageProxyAction
          state="edit"
          proxyIds={[proxy.productId]}
          proxyIdsDisabled={true}
          sourceId={proxy.source.id}
          multiplier={proxy.source.weight}
          multiple={false}
          deletable={true}
        >
          <FakeLink>
            <span>
              Proxy: {proxy.source.weight}x{" "}
              {productLabel(proxy.source.externalId, proxy.source.name)}
            </span>{" "}
            <EditOutlined />
          </FakeLink>
        </ManageProxyAction>
      ) : (
        <span>Proxy</span>
      )}
    </span>
  );
}
